import { Box, Heading, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import { SquareButton } from '@ui/buttons/SquareButton'

export const Button = styled(SquareButton)`
  text-decoration-thickness: 2px;
  text-underline-offset: 6px;

  &:hover {
    text-decoration-line: underline;
    text-decoration-thickness: 2px;
    text-underline-offset: 6px;
  }

  ${({ theme }) => theme.below.mobileXL`
    max-width: 100%;
  `}
`

export const BlockWrapper = styled(Box)`
  background-color: ${({ theme }) => theme.colors.smokeWhite};
  padding: ${({ theme }) => theme.spaces[2] * 10}px 0;

  ${({ theme }) => theme.below.laptop`
    padding: ${theme.spaces[4]}px 0;
  `}
`

export const ContentWrapper = styled(Box)`
  flex-direction: row;
  justify-content: center;

  ${({ theme }) => theme.below.laptop`
    flex-direction: column;
  `}
`

export const TextWrapper = styled(Box)`
  justify-content: center;
  width: ${({ textWidth }) => textWidth};

  ${({ theme }) => css`
    ${theme.below.laptop`
      width: 100%;
      text-align: center;
      align-items: center;
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xs}px;
    `}
  `}
`

export const Header = styled(Heading)`
  ${({ theme, textTransform }) => css`
    ${theme.getTypography('desktop', 'title', 'title1')}

    color: ${theme.newColors.primary};
    text-transform: ${textTransform || 'initial'};
    white-space: pre-wrap;

    ${theme.below.tabletS`
      ${theme.getTypography('mobile', 'title', 'title1')}
      white-space: initial;
    `}

    ${theme.below.tablet`
      text-transform: initial;
    `}
  `}
`

export const Subtitle = styled(Paragraph)`
  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'body', 'body1')}

    margin-top: ${theme.newSpaces.lg}px;
    max-width: 100%;
    text-align: start;

    ${theme.below.laptop`
      text-align: center;
    `}

    ${theme.below.tablet`
      text-align: center;
      margin-top: ${theme.newSpaces.sm}px;
    `}

    ${theme.below.tabletS`
      ${theme.getTypography('mobile', 'body', 'body1')}
    `}
  `}
`

export const HexagonWrapper = styled(Box)`
  margin-right: ${({ theme }) => theme.spaces[5]}px;
  ${({ theme }) => theme.below.laptop`
    margin: ${theme.spaces[3]}px auto;
  `}

  & > svg > path {
    transform: translateY(10px);
    transition: 0.3s all ease;
  }
`
